import { CompanyAlias } from 'api';
import { cashFlowLedgerUrl, companySummaryUrl } from 'common/config/urls';
import { ENTITY_QUERY_PARAM } from 'common/constants/pageFilters';

export type CompanyAliasSummary = Pick<CompanyAlias, 'id' | 'kind' | 'name'>;

const CONNECTOR_BY_KIND: Record<CompanyAlias.kind, string> = {
  [CompanyAlias.kind.ACQUIRED]: 'part of',
  [CompanyAlias.kind.FORMER_NAME]: 'now',
  [CompanyAlias.kind.DBA]: 'also known as',
};

// How an alias reads in search, e.g. "Campaign Monitor - now Marigold".
export const getCompanyAliasLabel = (alias: CompanyAliasSummary, companyName: string) =>
  `${alias.name} - ${CONNECTOR_BY_KIND[alias.kind]} ${companyName}`;

// An acquired company only exists as a Cash Flow Ledger entity; any other name opens the company itself.
export const getCompanyAliasPath = (alias: CompanyAliasSummary, firmSlug: string, companySlug: string) =>
  alias.kind === CompanyAlias.kind.ACQUIRED
    ? `${cashFlowLedgerUrl(firmSlug, companySlug)}?${ENTITY_QUERY_PARAM}=alias-${alias.id}`
    : companySummaryUrl(firmSlug, companySlug);
